<template>
    <div>
        <div style="text-align:center;margin-top:100px">
            <p style="font-size:22px;color:red;font-weight:600">
                <span style="margin-right:40px">{{ $t("pay.payable") }}：{{totalMoney}}{{locale=='en'?"CNY":"元"}}</span>
                <span>{{ $t("pay.realyPay") }}：{{payMoney}}{{locale=='en'?"CNY":"元"}}</span>
            </p>
        </div>
        <div class="title">
            <span>{{ $t("morder.payType") }}</span>
            <span style="color:red;margin-left:450px" v-if="countDown!=''">{{ $t("pay.paydown") }}:</span>
            <span style="color:red">{{countDown}}</span>
        </div>
        <div class="mline"></div>
        <div v-if="locale=='ch'" style="margin:30px 45px">
            <div  class="pay_line" v-for="(pay,index) in pays" :id="pay.ref" @click="selectPayWay(index)">
                <img src="http://www.medicalcircle.cn/lib/tpl/select.png" class="sPic" v-show="payType==index" />
                <img :src="pay.img" :id="pay.ref+'_img'" v-bind:class="{'oPic':payType==index}" />
                <div>{{pay.name}}</div>
            </div>
        </div>
        <div v-if="locale=='en'" style="margin-top:30px;">
            <div class="pay_line_en" v-for="(pay,index) in enpays" style="background-color:#B3002D;color:#FFF;border:0;margin-left:350px;font-size:16px">
                <img src="http://www.medicalcircle.cn/lib/tpl/select.png" class="sPic" />
                <img :src="pay.img" :id="pay.ref+'_img'" style="margin-top:-20px;" />
                <div>{{pay.name}}</div>
            </div>
        </div>
        <div style="clear:both;padding-top:100px;text-align:center">
            <button class="btn" @click="pay">{{ $t("pay.paySoon") }}</button>
        </div>
        <div v-if="doPay" @click="doPay=false" class="cover">
            <div class="scan">
                <img :src="scan" alt="">
                <div v-if="scanMsg===0" class="scan-msg">
                    <p>打开微信扫一扫</p>
                    <p>完成支付</p>
                </div>
                <div v-if="scanMsg===1" class="scan-msg">
                    <p> 打开支付宝扫一扫</p>
                    <p>完成支付</p>
                </div>
            </div>
        </div>
        <form action="" id="sxy" v-show="false">
            <input type="text" name="v_mid" id="v_mid" value="">
            <input type="text" name="v_oid" id="v_oid" value="">
            <input type="text" name="v_rcvname" id="v_rcvname" value="">
            <input type="text" name="v_rcvaddr" id="v_rcvaddr" value="">
            <input type="text" name="v_rcvtel" id="v_rcvtel" value="">
            <input type="text" name="v_rcvpost" id="v_rcvpost" value="">
            <input type="text" name="v_amount" id="v_amount" value="">
            <input type="text" name="v_ymd" id="v_ymd" value="">
            <input type="text" name="v_orderstatus" id="v_orderstatus" value="">
            <input type="text" name="v_ordername" id="v_ordername" value="">
            <input type="text" name="v_moneytype" id="v_moneytype" value="">
            <input type="text" name="v_url" id="v_url" value="">
            <input type="text" name="v_md5info" id="v_md5info" value="">
            <input type="text" name="v_userref" id="v_userref" value="">
            <input type="text" name="v_pmode" id="v_pmode" value="">
            <input type="text" name="v_merdata" id="v_merdata" value="">
        </form>
        <form action="" id="sxyen" method="post" v-show="false">
            <input type="text" name="v_mid" id="v_mid_en" value="">
            <input type="text" name="v_oid" id="v_oid_en" value="">
            <input type="text" name="v_rcvname" id="v_rcvname_en" value="">
            <input type="text" name="v_rcvaddr" id="v_rcvaddr_en" value="">
            <input type="text" name="v_rcvtel" id="v_rcvtel_en" value="">
            <input type="text" name="v_rcvpost" id="v_rcvpost_en" value="">
            <input type="text" name="v_amount" id="v_amount_en" value="">
            <input type="text" name="v_ymd" id="v_ymd_en" value="">
            <input type="text" name="v_orderstatus" id="v_orderstatus_en" value="">
            <input type="text" name="v_ordername" id="v_ordername_en" value="">
            <input type="text" name="v_moneytype" id="v_moneytype_en" value="">
            <input type="text" name="v_url" id="v_url_en" value="">
            <input type="text" name="v_md5info" id="v_md5info_en" value="">
        </form>
    </div>
</template>
<script>
export default {
    data() {
            return {
                doPay: false, //是否点击了支付按钮，用来控制二维码的显示
                scan: '', //二维码地址
                payType: '-1',
                totalMoney: 0, //应付金额
                payMoney: 0, //实付金额
                scanMsg: 0,
                form: {
                    v_merdata5: '',
                    v_mid: '',
                    v_oid: '',
                    v_rcvname: '',
                    v_rcvaddr: '',
                    v_rcvtel: '',
                    v_rcvpost: '',
                    v_amount: '',
                    v_ymd: '',
                    v_orderstatus: '',
                    v_ordername: '',
                    v_moneytype: '',
                    v_url: '',
                    v_md5info: '',
                    v_userref: '',
                    v_pmode: '',
                    action: 'hah'
                },
                pays: [{
                    'ref': "wx",
                    "name": "微信支付",
                    "img": "http://www.medicalcircle.cn/lib/tpl/weixin.png"
                }, {
                    'ref': "zfb",
                    "name": "支付宝支付",
                    "img": "http://www.medicalcircle.cn/lib/tpl/zhifubao.png"
                }, {
                    'ref': "bank",
                    "name": "网银支付",
                    "img": "http://www.medicalcircle.cn/lib/tpl/bank.png"
                }, {
                    'ref': "qbank",
                    "name": "快捷支付",
                    "img": "http://www.medicalcircle.cn/lib/tpl/qbank.png"
                }],
                enpays: [{
                    'ref': "qbank",
                    "name": "ICPAY",
                    "img": "http://www.medicalcircle.cn/lib/tpl/qbankb.png"
                }],
                register: {},
                countDown: '', //倒计时
                uid: '', //用户id
                cid: '', //会议id
                relid: '', //注册id regid
                expireDt: 0,
                locale: '',
                regid: '', //注册ID
                bookids: '', //酒店预订ID
                timer: '', //定时任务ID
                timer2: '' //倒计时定时任务
            }
        },
        mounted() {
            this.locale = localStorage.getItem("locale");
            let cid = localStorage.getItem('cid');
            this.cid = cid;
            let user = JSON.parse(localStorage.getItem('user'));
            this.uid = user.uId;
            this.getOrderInfo();
            this.getOrderStatus();
            if(this.locale=='en'){
                this.payType=4
            }
        },
        methods: {
            //        获取订单信息
            getOrderInfo() {
                this.postHttp('/medapp/api/template/register/info', {
                    uid: this.uid,
                    cid: this.cid * 1
                }).then((result) => {
                    let data = result.data;
                    //          如果是没有注册过就是1；
                    let regTotalMoney = data.register.regMoney;
                    let regMoney = (data.register.regPayway == '1' && data.register.regFl == '1' ? data.register.regMoney : 0);
                    //          所有的酒店信息
                    let hotelMoneys = data.hotel_book;
                    //          所有的酒店 未支付的 线上支付；
                    let hotelMoney = 0;
                    let totalHotelMoney = 0;
                    hotelMoneys.map((item, index) => {
                        //如果没有付款，并且是线上支付
                        if ((item.bookFl == '0' || item.bookFl == '1' || item.bookFl == '3') && item.bookPayway == '1') {
                            hotelMoney += item.bookMoney;
                        }
                        totalHotelMoney += item.bookMoney;
                    });
                    this.payMoney = hotelMoney + regMoney;
                    this.totalMoney = regTotalMoney + totalHotelMoney;
                    this.relid = data.register.regId;
                    this.register = data.register;
                    //设置倒计时 如果注册订单有线上未支付的 取register的到期时间
                    if (this.register.regPayway == '1' && (this.register.regFl == '0' || this.register.regFl == '1'|| this.register.regFl == '3')) {
                        this.regid = this.register.regId;
                        this.expireDt = this.register.regExpireDt;
                    }
                    for (let i = 0; i < hotelMoneys.length; i++) {
                        if (hotelMoneys[i].bookPayway == '1' && (hotelMoneys[i].bookFl == '0' || hotelMoneys[i].bookFl == '1'|| hotelMoneys[i].bookFl == '3')) {
                            this.bookids += hotelMoneys[i].bookId + "|";
                            this.expireDt = hotelMoneys[i].bookExpireDt;
                            break;
                        }
                    }
                    this.bookids = this.bookids.substr(0, this.bookids.length - 1);
                    this.setCountDown();
                });
            },
            setCountDown: function() {
                var leave2 = (this.expireDt - new Date().getTime()) % (3600 * 1000) //计算小时数后剩余的毫秒数 
                if(leave2<0){
                    this.countDown='';
                    return false;
                }
                var leave3 = Math.floor(leave2 % (1000 * 60) / 1000);
                var minutes = Math.floor(leave2 / (60 * 1000))
                this.timer2 = setInterval(() => {
                    --leave3;
                    if (leave3 > 0) {
                        this.countDown = (minutes < 10 ? '0' + minutes : minutes) + ":" + (leave3 < 10 ? '0' + leave3 : leave3);
                    } else if (leave3 == 0) {
                        leave3 = 59;
                        --minutes
                        if (minutes == -1) {
                            this.countDown = '';
                            clearInterval(this.timer);
                        }else{
                            this.countDown = (minutes < 10 ? '0' + minutes : minutes) + ":" + (leave3 < 10 ? '0' + leave3 : leave3);
                        }
                    }
                }, 1000);
            },
            selectPayWay: function(way) {
                this.payType = way;
                //way==1 微信支付
                if (this.payType == 0) {
                    this.scanMsg = 0;
                    document.getElementById('wx').className += ' weixin_select';
                    document.getElementById('wx_img').src = "http://www.medicalcircle.cn/lib/tpl/weixinb.png";

                    document.getElementById('zfb').className = 'pay_line';
                    document.getElementById('bank').className = 'pay_line';
                    document.getElementById('qbank').className = 'pay_line';
                    document.getElementById('qbank_img').src = "http://www.medicalcircle.cn/lib/tpl/qbank.png"
                } else if (this.payType == 1) {
                    this.scanMsg = 1;
                    document.getElementById('zfb').className += ' zfb_select';

                    document.getElementById('wx').className = 'pay_line';
                    document.getElementById('bank').className = 'pay_line';
                    document.getElementById('qbank').className = 'pay_line';
                    document.getElementById('wx_img').src = "http://www.medicalcircle.cn/lib/tpl/weixin.png";
                    document.getElementById('qbank_img').src = "http://www.medicalcircle.cn/lib/tpl/qbank.png"
                } else if (this.payType == 2) {
                    document.getElementById('bank').className += ' bank_select';

                    document.getElementById('wx').className = 'pay_line';
                    document.getElementById('zfb').className = 'pay_line';
                    document.getElementById('qbank').className = 'pay_line';
                    document.getElementById('wx_img').src = "http://www.medicalcircle.cn/lib/tpl/weixin.png";
                    document.getElementById('qbank_img').src = "http://www.medicalcircle.cn/lib/tpl/qbank.png"
                } else if (this.payType == 3) {
                    document.getElementById('qbank').className += ' qbank_select';
                    document.getElementById('qbank_img').src = "http://www.medicalcircle.cn/lib/tpl/qbankb.png"

                    document.getElementById('zfb').className = 'pay_line';
                    document.getElementById('bank').className = 'pay_line';
                    document.getElementById('wx').className = 'pay_line';
                    document.getElementById('wx_img').src = "http://www.medicalcircle.cn/lib/tpl/weixin.png"
                }
            },
            pay() {
                //首信易微信支付
                if (this.payType == '-1') {
                    return false;
                }
                if (this.payType === 0) {
                    let param = {
                        order_type: "1",
                        pay_type: 'PAYEASE_WECHAT',
                        uid: this.uid,
                        regid: this.regid, //regid
                        bookids: this.bookids,
                        src: '2'
                    };
                    this.postHttp('/medapp/api/pay/template/order', param).then((result) => {
                        this.doPay = true;
                        this.scan = result.data.scan.bankurl;
                        // this.getOrderStatus(); //获取支付状态
                    })
                }
                //首信易支付宝支付
                if (this.payType === 1) {
                    let param = {
                        order_type: "1",
                        pay_type: 'PAYEASE_ALIPAY',
                        uid: this.uid,
                        regid: this.regid, //regid
                        bookids: this.bookids,
                        src: '2'
                    };
                    this.postHttp('/medapp/api/pay/template/order', param).then((result) => {
                        this.doPay = true;
                        this.scan = result.data.scan.bankurl;
                        // this.getOrderStatus(); //获取支付状态
                    })
                }
                //pc端普通支付
                if (this.payType === 2) {
                    let param = {
                        order_type: "1",
                        pay_type: 'PAYEASE',
                        uid: this.uid,
                        regid: this.regid, //regid
                        bookids: this.bookids,
                        src: '2'
                    };
                    this.postHttp('/medapp/api/pay/template/order', param).then((result) => {
                        let data = result.data.payease;
                        this.setFormFields(data);
                        document.getElementById('sxy').action = 'https://pay.yizhifubj.com/prs/user_payment.checkit';
                        document.getElementById('sxy').submit();

                    })
                }
                //pc端普通支付
                if (this.payType === 3) {
                    let param = {
                        order_type: "1",
                        pay_type: 'PAYEASE',
                        uid: this.uid,
                        regid: this.regid, //regid
                        bookids: this.bookids,
                        src: '2'
                    };
                    this.postHttp('/medapp/api/pay/template/order', param).then((result) => {
                        let data = result.data.payease;
                        this.setFormFields(data);
                        document.getElementById('sxy').action = 'https://pay.yizhifubj.com/customer/gb/pay_bank.jsp';
                        document.getElementById('sxy').submit();
                    })
                }
                //外卡支付ICPAY
                if (this.payType === 4) {
                    let param = {
                        order_type: "1",
                        pay_type: 'PAYEASE_FOREIGN',
                        uid: this.uid,
                        regid: this.regid, //regid
                        bookids: this.bookids,
                        src: '2'
                    };
                    this.postHttp('/medapp/api/pay/template/order', param).then((result) => {
                        let data = result.data.payease;
                        console.log(JSON.stringify(data));
                        this.setFormFieldsEn(data);
                        document.getElementById('sxyen').action = 'https://pay.yizhifubj.com/prs/e_user_payment.checkit';
                        document.getElementById('sxyen').submit();
                    })
                }

            },
            //      设置表单字段
            setFormFields(data) {
                document.getElementById("v_mid").value = data.v_mid;
                document.getElementById("v_oid").value = data.v_oid;
                document.getElementById("v_rcvname").value = data.v_rcvname;
                document.getElementById("v_rcvaddr").value = data.v_rcvaddr;
                document.getElementById("v_rcvtel").value = data.v_rcvtel;
                document.getElementById("v_rcvpost").value = data.v_rcvpost;
                document.getElementById("v_amount").value = data.v_amount;
                document.getElementById("v_ymd").value = data.v_ymd;
                document.getElementById("v_orderstatus").value = data.v_orderstatus;
                document.getElementById("v_ordername").value = data.v_ordername;
                document.getElementById("v_moneytype").value = data.v_moneytype;
                document.getElementById("v_url").value = data.v_url;
                document.getElementById("v_md5info").value = data.v_md5info;
                document.getElementById("v_userref").value = data.v_userref;
                document.getElementById("v_pmode").value = data.v_pmode;
                document.getElementById("v_merdata").value = data.v_merdata;
            },
            setFormFieldsEn(data) {
                document.getElementById("v_mid_en").value = data.v_mid;
                document.getElementById("v_oid_en").value = data.v_oid;
                document.getElementById("v_rcvname_en").value = data.v_rcvname;
                document.getElementById("v_rcvaddr_en").value = data.v_rcvaddr;
                document.getElementById("v_rcvtel_en").value = data.v_rcvtel;
                document.getElementById("v_rcvpost_en").value = data.v_rcvpost;
                document.getElementById("v_amount_en").value = data.v_amount;
                document.getElementById("v_ymd_en").value = data.v_ymd;
                document.getElementById("v_orderstatus_en").value = data.v_orderstatus;
                document.getElementById("v_ordername_en").value = data.v_ordername;
                document.getElementById("v_moneytype_en").value = data.v_moneytype;
                document.getElementById("v_url_en").value = data.v_url;
                document.getElementById("v_md5info_en").value = data.v_md5info;
            },
            getOrderStatus() {
                this.timer = setInterval(() => {
                    this.postHttp('/medapp/api/pay/order/status', {
                            regid: this.regid,
                            bookids: this.bookids
                        })
                        .then((result) => {
                            console.log(result.data)
                            if (result.data.status == '2') { //如果支付成功 跳转到报名信息页面
                                this.$router.push("/order/info")
                            } else {

                            }
                        })
                }, 2000)

            }
        },
        beforeDestroy() {
            clearInterval(this.timer)
            clearInterval(this.timer2)
        }
}
</script>
<style scoped>
.cover {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10;
    background-color: rgba(100, 100, 100, .6);
    left: 0;
    top: 0;
}

.scan {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
    padding: 20px;
    background-color: #ffffff;
}

.scan-msg {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
}

.title {
    font-size: 18px;
    color: #000;
    font-weight: 600;
    margin-top: 40px;
}

.mline {
    height: 1px;
    width: 100%;
    background: #DCDCDC;
    margin-top: 5px;
}

.o_label {
    margin-left: 30px;
    margin-top: 20px
}

.sPic {
    padding-left: 110px;
    margin-top: -40px;
}

.oPic {
    margin-top: -20px;
}

.mPic {
    margin-top: 10px;
}

.pay_line {
    cursor: pointer;
    float: left;
    text-align: center;
    height: 140px;
    width: 143px;
    border: 1px solid;
    border-radius: 5px;
    border-color: #53B648;
    margin-right: 40px;
    padding-top: 20px;
}


.pay_line_en {
    cursor: pointer;
    text-align: center;
    height: 140px;
    width: 143px;
    border: 1px solid;
    border-radius: 5px;
    border-color: #53B648;
    /*margin-right: 40px;*/
    padding-top: 20px;
}

.pay_line div {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: .1em
    /*color:#53B648;*/
}

.weixin_select {
    background-color: #53B648;
    color: #FFF;
}

.bank_select {
    background-color: #EEEEEE;
    color: #000;
}

.zfb_select {
    background-color: #1CABEE;
    color: #FFF;
}

.qbank_select {
    background-color: #B3002D;
    color: #FFF;
}

.h_main {
    margin-top: 30px;
}

.ht_name_circle {
    width: 220px;
    height: 40px;
    border-radius: 30px;
    outline: none;
    border: 1px solid #cfcfcf;
    color: #000;
    background-color: #FFF;
    font-size: 16px;
    margin-right: 30px;
}

label {
    font-size: 16px;
    color: #000;
    font-weight: 500;
    margin-right: 10px;
    letter-spacing: .1em;
    margin-right: -.1em;
}

.pay {
    margin-top: 20px;
}

.pay p {
    margin-top: 5px;
}

.pay span {
    font-size: 16px;
    color: #000;
    font-weight: 600;
}

.btn {
    width: 300px;
    height: 50px;
    border-radius: 30px;
    outline: none;
    border: 0;
    color: #FFF;
    background-color: #F39800;
    font-size: 18px;
    cursor: pointer;
}

.foot {
    text-align: center;
    margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// pay.vue?3b802620